import React from 'react';

const seoFactorsList = [
  {
    category: 'On-page SEO',
    items: [
      {
        title: 'Keyword Research:',
        desc: 'We identify the popular words and phrases people use in search engines to find relevant information.'
      },
      {
        title: 'Google Search Console:',
        desc: 'Helps monitor and analyze how your website appears and performs in Google search results.'
      },
      {
        title: 'Google Analytics:',
        desc: 'Offers an idea of how users interact with your website. It also includes their behavior and traffic patterns.'
      },
      {
        title: 'Google Tag Manager:',
        desc: 'Allows easy management of marketing tags, such as code snippets and tracking pixels, without modifying site code directly.'
      },

      {
        title: 'Meta Tags Optimization:',
        desc: 'It refines the meta title and description to help search engines understand what your website is about.'
      },
      {
        title: 'Content Optimization:',
        desc: 'Improves your website content to make it more attractive. Optimized content is searched for by more people.'
      },
      {
        title: 'Internal Linking:',
        desc: 'It links the related content to improve website navigation for users and helps search engines index your pages more effectively.'
      },
      {
        title: 'Sitemap:',
        desc: 'A structured file that lists all the pages of your website. A sitemap guides search engines about indexation and the priority of each page.'
      },
      {
        title: 'Broken Links Redirects:',
        desc: 'Avoids poor user experience and guides visitors from nonfunctional links to appropriate, working pages.'
      },
    ]
  }

];

function SeoFactorsScrollSection() {
  const handleCtaClick = (e) => {
    e.preventDefault();
    const formEl = document.querySelector('.contact-section') || document.getElementById('contact-form');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="seo-factors-scroll-section">
      <div className="container seo-factors-container">
        {/* Left Column: Fixed / Sticky Information */}
        <div className="seo-factors-left">
          <h2 className="seo-factors-title">
            Important <span className="seo-red-title">SEO Factors</span> to rank you on top of the Google.
          </h2>

          <p className="seo-factors-desc">
            SEO is a part of <a href="/digital-marketing/" className="seo-red-link">digital marketing</a>, and it is a detailed process that requires proper understanding and expertise if you want to do it correctly. Ace your SEO game with our <strong>rank on top SEO service</strong>, which makes your website visible and credible for search engines. Some important factors need to be considered if you want to rank your site at the top of Google.
          </p>

          <button className="btn-seo-red-pill" onClick={handleCtaClick}>
            Start My App Project
          </button>
        </div>

        {/* Right Column: Scrollable Factors List */}
        <div className="seo-factors-right">
          <div className="seo-factors-scroll-box">
            {seoFactorsList.map((group, groupIndex) => (
              <div key={groupIndex} className="seo-factors-group">
                <h3 className="seo-factors-category-title">{group.category}</h3>

                <div className="seo-factors-items">
                  {group.items.map((item, itemIndex) => (
                    <div key={itemIndex} className="seo-factor-item">
                      <h4 className="seo-factor-item-title">{item.title}</h4>
                      <p className="seo-factor-item-desc">{item.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default SeoFactorsScrollSection;
